export default __webpack_public_path__ + "static/media/pricing5.e5b522d0.jpg";